import _bundle from '../index'
export const bundle = _bundle

import _storeV1 from '../../core/store/v1'
export const storeV1 = _storeV1

import _serverV1 from '../../core/server/v1'
export const serverV1 = _serverV1

import _urlV1 from '../../core/url/v1'
export const urlV1 = _urlV1

import _cookiesV1 from '../../core/cookies/v1'
export const cookiesV1 = _cookiesV1

import _apiV1 from '../../core/api/v1'
export const apiV1 = _apiV1

import getSe from '../index.js'

const modifySeRequest = (fields) => (request) => {
    if (request.capacity) {
        const values = [...fields.capacity]
        values.sort((a, b) => a.value - b.value)
        const index = values.findIndex(({ id }) => id === request.capacity)
        request.capacity = values.slice(index).map(({ id }) => id)
    }
    return request
}

// preset configs
const presetV1 = async ({ on, ...props }) => {
    const { init } = await getSe({
        store: {
            v1: storeV1
        },
        server: {
            v1: serverV1
        },
        url: {
            v1: urlV1
        },
        cookies: {
            v1: cookiesV1
        },
        api: {
            v1: apiV1
        }
    })
    const { getApi } = init({
        ...props,
        versions: {
            store: 'v1',
            url: 'v1',
            cookies: 'v1',
            server: 'v1'
        },
        modifySeRequest: (props.modifySeRequest || modifySeRequest)(props.fields)
    })
    const api = await getApi({
        versions: {
            api: 'v1'
        }
    })
    if (on && on.api) {
        on.api({ api })
    }

    const syncUrl = props.syncUrl === undefined ? true : props.syncUrl
    api.batch(() => {
        api.restoreCookies()
        api.syncCookies(true) // before restoring url to sync
        if (syncUrl) {
            api.restoreUrl()
        }
    })
    if (on && on.afterRestore) {
        on.afterRestore({ api })
    }
    if (syncUrl) {
        api.syncUrl(true)
        if (on && on.afterSyncUrl) {
            on.afterSyncUrl({ api })
        }
    }

    return api
}
export default presetV1
